import { useContext } from "react";
import { useLocation, useRoute } from "wouter";
import { CartContext } from "../../Components/Overlay/Overlay";
import products from "../../products.json";
import "./ProductOverlay.css";

interface ProductOverlayProps {
  mobileScreen: boolean;
}

function ProductOverlay({ mobileScreen }: ProductOverlayProps) {
  const [, params] = useRoute("/item/:id");
  const [, setLocation] = useLocation();
  const { cart, setCart } = useContext(CartContext);

  const color = params?.id ? "white" : "black";

  function addToCart() {
    const tempCart = structuredClone(cart);
    const productId = Number(params?.id);
    if (productId === 1) {
      tempCart.cube++;
    } else if (productId === 2) {
      tempCart.sphere++;
    } else if (productId === 3) {
      tempCart.cone++;
    }
    setCart(tempCart);
  }

  function checkAddedToCart() {
    const productId = Number(params?.id);
    if (productId === 1) {
      return cart?.cube > 0;
    } else if (productId === 2) {
      return cart?.sphere > 0;
    } else if (productId === 3) {
      return cart?.cone > 0;
    }
    return false;
  }

  const addedToCart = checkAddedToCart();

  let product;
  if (params?.id) {
    product = products.products[Number(params?.id) - 1];
  }

  if (params?.id !== undefined) {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          color: color,
        }}
      >
        {mobileScreen ? (
          <></>
        ) : (
          <div
            style={{
              position: "absolute",
              top: mobileScreen ? "65%" : "40%",
              left: mobileScreen ? "10%" : "15%",
              fontSize: mobileScreen ? "48px" : "78px",
              zIndex: 500,
              animation: "fadeInArrow 1s",
              cursor: "pointer",
            }}
            onClick={() => setLocation("/")}
          >
            <h3
              style={{
                cursor: "pointer",
                margin: 0,
                textAlign: "center",
                animation: "floating 4s infinite ease-in-out",
              }}
            >
              &larr;
            </h3>
          </div>
        )}
        <div
          style={{
            position: "absolute",
            top: mobileScreen ? "96px" : "20%",
            left: mobileScreen ? "32px" : "70%",
            animation: "fadeInLeft 1s",
            mixBlendMode: "lighten",
          }}
        >
          <h2
            style={{
              fontSize: "32px",
              marginBottom: 8,
            }}
          >
            {product?.name}
          </h2>
          <p
            style={{
              animation: "fadeIn 1s",
              fontSize: "20px",
              marginTop: "12px",
              marginBottom: "8px",
              paddingRight: "48px",
            }}
          >
            {product?.description}
          </p>
          <p
            style={{
              animation: "fadeIn 1s",
              fontSize: "16px",
              paddingRight: "48px",
              opacity: 0.8,
            }}
          >
            {product?.colorDescription}
          </p>
          {mobileScreen ? (
            <></>
          ) : (
            <button
              className={"add-to-cart" + (addedToCart ? " added-to-cart" : "")}
              onClick={() => addToCart()}
              style={{
                position: "absolute",
                backgroundColor: "transparent",
                marginTop: "16px",
                color: color,
                borderColor: color,
                border: "2px solid",
                width: "10em",
                height: "2.5em",
                zIndex: 500,
                cursor: "pointer",
                fontSize: "22px",
                padding: "10px",
              }}
            >
              {addedToCart ? "✓ Added to cart" : "+ Add to cart"}
            </button>
          )}
        </div>

        {mobileScreen ? (
          <button
            className={
              "add-to-cart add-to-cart-mobile" +
              (addedToCart ? " added-to-cart" : "")
            }
            onClick={() => addToCart()}
            style={{
              position: "absolute",
              backgroundColor: "transparent",
              top: "80%",
              left: "50%",
              color: color,
              borderColor: color,
              border: "2px solid",
              zIndex: 500,
              width: "10em",
              height: "2.5em",
              cursor: "pointer",
              fontSize: "22px",
              padding: "10px",
            }}
          >
            {addedToCart ? "✓ Added to cart" : "+ Add to cart"}
          </button>
        ) : (
          <></>
        )}
      </div>
    );
  } else {
    return <></>;
  }
}

export default ProductOverlay;
